export const SMART_TOPOLOGY_MARKER_SIZE = 20;